var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('transition',{attrs:{"name":"np-fade"}},[(_vm.isLoading)?_c('div',{staticClass:"is-loading screen-loader flex"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }